import React, { useState, useEffect } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/summer.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import MainCalculatorsList from './MainCalculators';
const TITLE = "Berapa Hari Lagi Musim Panas 2026 - Hitung Mundur Awal Musim Panas";
const DESCRIPTION = "Berapa hari lagi musim panas 2026, kapan musim panas 2026 dimulai, tanggal awal musim panas 2026, kapan musim panas 2026 berakhir, hitung mundur musim panas, jadwal musim panas 2026, berapa hari lagi musim panas, kapan musim panas di Arab Saudi, tanggal awal musim panas 1446 H, kapan musim panas 2026 berakhir, berapa hari lagi musim panas 1446, jadwal awal musim panas di negara-negara Arab";
const KEYWORDS = "berapa hari lagi musim panas 2026, kapan musim panas 2026 dimulai, tanggal awal musim panas 2026, kapan musim panas 2026 berakhir, hitung mundur musim panas, jadwal musim panas 2026, berapa hari lagi musim panas, musim panas 2026, summer 2026";
const OG_URL = "https://do-calculate.com/articles-id/summer/";
function SummerCountdown() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const summerStartDate = new Date("2026-06-20T00:00:00");
    const summerEndDate = new Date("2026-09-22T00:00:00");
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(summerStartDate));
    const [isSummerStarted, setIsSummerStarted] = useState(new Date() >= summerStartDate);
    const [isSummerEnded, setIsSummerEnded] = useState(new Date() >= summerEndDate);
    useEffect(() => {
        const timer = setTimeout(() => {
            const now = new Date();
            setIsSummerStarted(now >= summerStartDate);
            setIsSummerEnded(now >= summerEndDate);
            if (!isSummerStarted) {
                setTimeLeft(calculateTimeLeft(summerStartDate));
            } else if (!isSummerEnded) {
                setTimeLeft(calculateTimeLeft(summerEndDate));
            }
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft, isSummerStarted, isSummerEnded]);
    const summerDates = [
        { name: 'Musim Panas 2026', start: new Date("2026-06-20T00:00:00"), end: new Date("2026-09-22T00:00:00") },
        { name: 'Musim Panas 2026', start: new Date("2026-06-21T00:00:00"), end: new Date("2026-09-23T00:00:00") },
        { name: 'Musim Panas 2027', start: new Date("2027-06-21T00:00:00"), end: new Date("2027-09-23T00:00:00") },
        { name: 'Musim Panas 2028', start: new Date("2028-06-20T00:00:00"), end: new Date("2028-09-22T00:00:00") },
        { name: 'Musim Panas 2029', start: new Date("2029-06-20T00:00:00"), end: new Date("2029-09-22T00:00:00") },
    ];
    return (
        <div className="ltr">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className='p-3 mb-2 bg-success text-white'>
                Berapa Hari Lagi Musim Panas 2026
            </h1>
            <div>
                <BlinkingText text={`Berapa hari lagi ${isSummerStarted ? 'akhir' : 'awal'} musim panas 2026: ${isSummerStarted ?
                    'Musim panas 2026 dimulai hari Jumat tanggal 20/06/2026 Masehi dan berakhir hari Senin tanggal 22/09/2026 Masehi' :
                    'Diperkirakan musim panas 2026 dimulai hari Jumat tanggal 20/06/2026 Masehi dan berakhir hari Senin tanggal 22/09/2026 Masehi'}`} />
            </div>
            <div className="row">
                <div id="timer" style={{ width: '100%', fontSize: '40px' }}>
                    <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th>Hari</th>
                                <th>Jam</th>
                                <th>Menit</th>
                                <th>Detik</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td id="days">{timeLeft.days}</td>
                                <td id="hours">{timeLeft.hours}</td>
                                <td id="minutes">{timeLeft.minutes}</td>
                                <td id="seconds">{timeLeft.seconds}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div style={{ textAlign: 'center', fontSize: '24px', marginTop: '10px' }}>
                        {isSummerStarted ?
                            (isSummerEnded ? 'Musim panas telah berakhir untuk tahun ini' : 'Musim panas telah dimulai!') :
                            'Menuju awal musim panas'}
                    </div>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div>
                        <h2 className='p-3 mb-2 bg-success text-white' style={{ color: '#333', fontSize: '36px', textAlign: 'center' }}>Jadwal Musim Panas Mendatang</h2>
                        <table style={{ fontSize: '24px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f2f2f2' }}>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Musim Panas</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Mulai</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Berakhir</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Sisa Hari</th>
                                </tr>
                            </thead>
                            <tbody>
                                {summerDates.map((date, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                        <td style={{ padding: '12px' }}>{date.name}</td>
                                        <td style={{ padding: '12px' }}>{date.start.toLocaleDateString('en-GB')}</td>
                                        <td style={{ padding: '12px' }}>{date.end.toLocaleDateString('en-GB')}</td>
                                        <td style={{ padding: '12px' }}>{calculateTimeLeft(date.start).days} hari</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col">
                    <MainCalculatorsList />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className='p-3 mb-2 bg-success text-white'>Berapa Hari Lagi Musim Panas</h3>
                    <p>
                        Dalam artikel ini, kami menyajikan hitung mundur lengkap menuju musim panas, agar Anda selalu mengetahui berapa hari lagi awal atau akhir musim ini. Banyak di antara kita yang bertanya berapa hari lagi musim panas, oleh karena itu kami hadirkan hitung mundur musim panas agar Anda dapat mengetahui berapa hari lagi awal atau akhir musim panas.
                    </p>
                    <p>
                        Musim panas tahun 2026/1446 H dimulai pada tanggal 20/06/2026 Masehi hari Jumat, dan berakhir pada tanggal 22/09/2026 Masehi hari Senin. Anda dapat melihat hitung mundur musim panas di artikel ini.
                    </p>
                    <p>
                        Temukan di sini hitung mundur musim panas, di mana Anda dapat mengetahui berapa hari lagi awal atau akhir musim panas.
                    </p>
                    <hr />
                    <RelatedLinks />
                    <hr />
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        Hitung Berapa Hari Lagi Musim Panas
                    </h3>
                    <p>
                        Melalui program hitung mundur musim panas, Anda dapat mengetahui berapa hari lagi awal atau akhir musim panas dalam kalender Masehi maupun Hijriah, serta mengetahui sisa hari menuju musim panas, kapan musim panas dimulai, dan kapan berakhir.
                    </p>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        Musim Panas
                    </h3>
                    <p>
                        Musim panas adalah salah satu dari empat musim dalam setahun, yang ditandai dengan tingginya suhu udara, panjangnya siang hari, dan pendeknya malam. Di belahan bumi utara, musim panas dimulai pada tanggal 20 atau 21 Juni dan berakhir pada tanggal 22 atau 23 September setiap tahunnya. Musim panas adalah waktu untuk liburan, bersantai, dan bepergian ke daerah pantai atau dataran tinggi untuk menghindari terik matahari.
                    </p>
                    <div>
                        <br />
                        <img
                            src={imageUrl}
                            alt="Berapa hari lagi musim panas 2026"
                            width="800"
                            height="450"
                            style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                            loading="lazy"
                        />
                        <br />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default SummerCountdown;
